<nav class="navbar navbar-dark bg-dark sticky-top">
    <div class="container">
      <a class="navbar-brand" href="/">
        <h3>HOTEL SUIZO</h3>      
      </a>  
      <span class="navbar-brand" >{{ 'motor.softwarereservas' | translate }}</span>  
    </div>
  </nav>